import { FC } from 'react';

import { Primary, Secondary } from './components';

const Selects: FC = () => {
  return (
    <>
      <Primary />
      <Secondary />
    </>
  );
};

export default Selects;
